import { callPostApi } from '../apiCallerProxy';
import { reachEstimatorApiFactory } from './reachEstimatorApiFactory';

export * from './hooks';

export const { getReachEstimation } = reachEstimatorApiFactory({
    callPostApi,
});
